<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign.gt-xs="space-between center">
    <h1>Andamentos do Concurso:</h1>
    <button mat-raised-button color="primary" (click)="adicionar()" [disabled]="concursoFinalizado"><mat-icon>add</mat-icon> Adicionar</button>
  </div>
  <h2>{{tituloConcurso}}</h2>

  <app-andamento-form
    *ngIf="cadastro"
    [idConcurso]="idConcurso"
    [tipoConcurso]="tipoConcurso"
    [valorInscricao]="valorInscricao"
    [andamento]="andamento"
    [possuiRecursoDeferidoResultadoFinal]="possuiRecursoDeferidoResultadoFinal"
    (andamentoUpdate)="update($event)">
  </app-andamento-form>

  <app-search-input #searchInput (search)="search($event)" placeholder=""></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Visível ao Candidato</th>
        <td mat-cell *matCellDef="let row">
          {{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let row">
          {{ row.tipo.toString() }}
        </td>
      </ng-container>
      <ng-container matColumnDef="titulo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Informações</th>
        <td mat-cell *matCellDef="let row">
          <b>{{ row.titulo }}</b>
          <br />{{ row.complemento }}
        </td>
      </ng-container>
      <ng-container matColumnDef="publicacao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Publicação</th>
        <td mat-cell *matCellDef="let row">
          {{ row.publicacao | date : 'dd/MM/yyyy' }} - {{ row.pagina }} - {{ row.sessao }}
        </td>
      </ng-container>
      <ng-container matColumnDef="recurso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Recurso</th>
        <td mat-cell *matCellDef="let row">
          {{ row.recursoInicio | date : 'dd/MM/yyyy' }} - {{ row.recursoFim | date : 'dd/MM/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="conclusao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Conclusão e Notificação</th>
        <td mat-cell *matCellDef="let row">          
          {{ row.dataConclusao | date : 'dd/MM/yyyy HH:mm:ss' }}
          <mat-icon *ngIf="row.andamentoConcluido" color="primary" title="Andamento Concluído">check</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button color="basic" [matMenuTriggerFor]="menu" title="Opções">
            <mat-icon>settings</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              title="Anexo"
              (click)="verAnexo('andamento/' + row.id, row.anexo, row.titulo)"
              [disabled]="!row.anexo">
              <mat-icon>attachment</mat-icon><span>Anexo</span>
            </button>
            <button mat-menu-item title="Concluir" (click)="concluir(row, i)" [disabled]="row.andamentoConcluido || concursoFinalizado">
              <mat-icon>check</mat-icon><span>Concluir</span>
            </button>
            <button mat-menu-item title="Editar" (click)="editar(row, i)" [disabled]="row.andamentoConcluido || concursoFinalizado">
              <mat-icon>edit</mat-icon><span>Editar</span>
            </button>
            <button mat-menu-item title="Excluir" (click)="excluir(row, i)" [disabled]="row.andamentoConcluido || concursoFinalizado">
              <mat-icon>delete</mat-icon>Deletar<span></span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="8">
          <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator></app-default-paginator>
  </div>
</div>
